<script lang="ts" setup>
import { shallowRef, watch } from 'vue'

import type { Props } from './types'

const props = withDefaults(defineProps<Props>(), {
  hiddenElements: () => []
})

const createUnitDataItem = (icon: any, value: any, formatter?: (val: any) => string) => ({
  icon,
  value: value != null ? (formatter ? formatter(value) : value) : ''
})

const generateUnitData = () => [
  createUnitDataItem('https://assets.lahaus.com/static/svgs/icons/Room.svg', props.data?.bedroom),
  createUnitDataItem('https://assets.lahaus.com/static/svgs/icons/Bath.svg', props.data?.bathroom),
  createUnitDataItem('https://assets.lahaus.com/static/svgs/icons/Car.svg', props.data?.parkingLots)
]

const isElementVisible = (index: number, hiddenElements: number[]) => !hiddenElements.includes(index)

const showElement = (index: number) => isElementVisible(index, props.hiddenElements)

const updateUnitData = (unitDataRef: Ref<UnitData[]>) => {
  unitDataRef.value = generateUnitData()
}

const unitData = shallowRef(generateUnitData())

watch(() => props.data, () => updateUnitData(unitData))
</script>

<script lang="ts">
export default {
  name: 'AppIconsBar'
}
</script>

<template>
  <div class="icons-bar-v2 flex items-center gap-4 icon-bar">
    <template
      v-for="(data, index) in unitData"
      :key="index">
      <span
        v-if="showElement(index)"
        class="icon-bar__icon w-24 h-24 pointer-events-none">
        <img :src="data.icon"></img>
      </span>

      <span
        v-if="showElement(index)"
        class="icon-bar__text text-20">
        {{ data.value || 0 }}
      </span>

      <span
        v-if="index !== unitData.length - 1 && data.value"
        class="w-16 h-16" />
    </template>
  </div>
</template>

<style lang="scss">
.lh-roomie-v2 {
  .icons-bar-v2 {
    color: #004132;

    svg {
      fill: #004132;
    }
  }
}
</style>
